import { urlFunction } from "app/main/types";
import { cleanStringForURL } from "app/main/urlFormatter";
import { clientConfig } from "app/config";

export const exchangeRateUrlFunction: urlFunction = (isin, title) => {
    const cleanName = cleanStringForURL(title);
    return `${clientConfig.urlPathPrefixStocks}waehrung/${cleanName}/${isin.toLowerCase()}`;
};
